import { environment } from 'src/environments/environment';

export function getVersionDisplay(version: string): string {
  return `V${version}`;
}

export function isTestEnvironment(): boolean {
  if (!environment.production) return true;

  const values = [
    getBrowserHostname(),
    environment.apiUrl,
    environment.webUrl,
    environment.downloadUrl,
    environment.baseUrl
  ];

  return values.some(value => /(sit|uat|test|localhost|127\.0\.0\.1)/i.test(value || ''));
}

function getBrowserHostname(): string {
  return typeof window === 'undefined' ? '' : window.location.hostname;
}
